module.exports = __webpack_public_path__ + "static/assets/df66578b128b26f9b1797ab0eb03c615.svg";